import { memo } from 'react';
import { Group, Text } from '@mantine/core';
import { COLOR_RANKING, OPACITY } from '@lib/map-results';
import classes from './map-react-legend-overlay.module.css';

const legendStyle = {
  display: 'inline-block',
  width: 20,
  height: 12,
  marginRight: 4,
  border: '1px solid black',
  opacity: 1.0 - OPACITY,
};

const divStyle: React.CSSProperties = {
  position: 'absolute',
  zIndex: 10,
  bottom: 50,
  right: 0,
  maxWidth: '245px',
  background: '#fff',
  boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
  padding: '3px 24px',
  margin: '20px',
  fontSize: '13px',
  lineHeight: 2,
  color: '#6b6b76',
  textTransform: 'uppercase',
  outline: 'none',
};

function MapLegend() {
  const ColorItems = () =>
    COLOR_RANKING.map((ranking, index) => (
      <Group key={ranking.color}>
        <div className={classes.legendStyle} style={{ background: ranking.color, ...legendStyle }} />
        <Text p={3} size="13px">
          {ranking.text} ({index + 1})
        </Text>
      </Group>
    ));
  return (
    <div style={{ ...divStyle }}>
      <h3>Your World</h3>
      <div>
        <ColorItems />
      </div>
    </div>
  );
}

export default memo(MapLegend);
